module.exports = __webpack_public_path__ + "img/cz.91d9506e.svg";